import { store } from "@/vuex/store.js"

const GRAPH_BASE = "https://graph.microsoft.com/v1.0"; // Replace with your actual Graph base URL

// Function to handle common fetch logic
/**
 *
 * @param {*} method GET,POST,PUT,DELETE etc.
 * @param {*} apiPath Path for calling general function
 * @param {*} no_base Bool value for using proxy later.
 * @param {*} body body value when doing POST/PUT req
 * @param {*} headers Inside GET value requests
 * @param {*} response_type value of response type 1=JSON, 2=BLOB, 3=array buffer
 * @returns
 */
async function makeGraphRequest(
  method,
  apiPath,
  no_base = true,
  body = null,
  headers = {},
  response_type = 1
) {

  const accessToken = store.state.aToken;

  console.log(headers)
  let options = {
    method,
    headers: {
      authorization: `Bearer ${accessToken}`,
      ...headers,
    },
  };


  if(body)
  options["body"] = body


  const url = no_base?`${GRAPH_BASE}${apiPath}`:apiPath;
  console.log("Fetching url", url, options);
  const resp = await fetch(url, options);

  if (!resp.ok) {
    throw new Error(`Call to ${url} failed: ${resp.statusText}`);
  } else {
    switch (response_type) {
      case 1:
        return await resp.json();
      case 2:
        return resp.blob();
       case 3:
          return true;
      default:
        return await resp.json();
    }
  }
}

// Individual functions for each HTTP method

// GET
async function msGraphGet(
  apiPath,
  no_base = true,
  headers = {},
  response_type = 1
) {
  return makeGraphRequest(
    "GET",
    apiPath,
    no_base,
    null,
    headers,
    response_type
  );
}

// POST
async function msGraphPost(
  apiPath,
  body,
  no_base = true,
  headers = {},
  response_type = 1
) {


  console.log("First station", apiPath,
  body,
  no_base,
  headers,
  response_type)
  return makeGraphRequest(
    "POST",
    apiPath,
    no_base,
    body,
    headers,
    response_type
  );
}

// PUT
async function msGraphPut(
  apiPath,
  body,
  no_base = true,
  headers = {},
  response_type = 1
) {
  return makeGraphRequest(
    "PUT",
    apiPath,
    no_base,
    body,
    headers,
    response_type
  );
}

// DELETE
async function msGraphDelete(
  apiPath,
  no_base = true,
  headers = {},
  response_type = 3
) {
  return makeGraphRequest(
    "DELETE",
    apiPath,
    no_base,
    null,
    headers,
    response_type 
  );
}

// Example Usage
// msGraphGet('/users');
// msGraphPost('/groups', { displayName: 'My Group', mailEnabled: true });
// msGraphPut('/me/photo/$value', fileBlob, true, { "Content-Type": "image/jpeg" });
// msGraphDelete('/groups/{group-id}');

export { msGraphDelete, msGraphGet, msGraphPost, msGraphPut };
